import {Routes} from '@angular/router';
import {CustomersPageComponent} from './customers-page/customers-page.component';
import {authGuard} from '../../../sdk/src/guards/auth-guard.guard';
import {GlobalLayoutComponent} from './global-layout.component';
import {GUsersPage} from './administration/user-page/users-page.component';
import {GUserRolesPage} from './administration/user-role-page/user-roles-page.component';
import {GCustomerUserMembershipsPage} from './administration/customer-user-memberships-page/customer-user-memberships-page.component';
import {GOO8ConnectorsPage} from './administration/oo8-connectors-page/oo8-connectors-page.component';
import {GJobsPage} from './administration/jobs-page/jobs-page.component';
import {GS3BucketsPage} from './administration/s3-buckets-page/s3-buckets-page.component';

export const globalRoutes: Routes = [
    {
        path: '',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        component: GlobalLayoutComponent,
        children: [
            {path: '', component: CustomersPageComponent, title: 'Customers'},
            {
                path: 'administration',
                children: [
                    {path: '', redirectTo: 'users', pathMatch: 'prefix'},
                    {path: 'users', component: GUsersPage},
                    {path: 'user-roles', component: GUserRolesPage},
                    {path: 'customer-user-memberships', component: GCustomerUserMembershipsPage},
                    {path: 'oo8-connectors', component: GOO8ConnectorsPage, title: 'OO8 Connectors'},
                    {path: 's3-buckets', component: GS3BucketsPage, title: 'S3 Buckets'},
                    {path: 'jobs-action', component: GJobsPage, title: 'Jobs - Action', data: {jobType: 'action'}}
                ]
            }
        ]
    }
];
